import { render } from "./OrderHistoryContainer.vue?vue&type=template&id=6f85c286"
import script from "./OrderHistoryContainer.vue?vue&type=script&lang=js"
export * from "./OrderHistoryContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__